import { render, staticRenderFns } from "./ExamineLongConsult.vue?vue&type=template&id=0ae66d3f&style=height%3A%20100%25%3B"
import script from "./ExamineLongConsult.vue?vue&type=script&lang=js"
export * from "./ExamineLongConsult.vue?vue&type=script&lang=js"
import style0 from "./ExamineLongConsult.vue?vue&type=style&index=0&id=0ae66d3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports